
























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { isEmpty } from 'lodash';
import * as api from '@/api';
import { Form, FormRules } from '@ss/mtd-vue';

interface Bulletin {
    id: number | null;
    content: string;
}

@Component({ name: 'rg-moses-bulletin' })
export default class RgMosesBulletin extends Vue {
    @Prop({ required: true })
    rgId: number;

    bulletins: Array<Bulletin> = [];

    bulletinEditingStage: Bulletin = {
        id: null,
        content: null
    };

    bulletinContent: string = '';
    bulletinId: number = null;

    submittingBulletin: boolean = false;

    bulletinEditingFormRules: FormRules = {
        content: [
            { required: true, message: '内容不可为空' },
            {
                max: 500,
                message: '公告内容不可超过500字'
            }
        ]
    };

    mounted() {
        this.getMosesBulletins();
    }

    async getMosesBulletins() {
        try {
            const res = await api.rgApi.getMosesBulletins({ rgId: this.rgId });
            const { code, data } = res;
            if (code === 200) {
                this.bulletins = data.items;
            } else {
                this.$mtd.message({ message: res.message, type: 'error' });
            }
        } catch (e) {
            console.log(e);
        }
    }

    startEditingBulletin(bulletinData: any) {
        if (isEmpty(bulletinData)) {
            // 如果正在添加，直接中止
            const lastItem = this.bulletins[this.bulletins.length - 1];
            if (lastItem && lastItem.id === null) {
                return;
            }
            const newItem = {
                id: null,
                title: '',
                content: ''
            };
            this.bulletins.push(newItem);
            this.bulletinEditingStage.content = newItem.content;
            return;
        }
        // 开始编辑
        this.bulletinEditingStage.id = bulletinData.id;
        this.bulletinEditingStage.content = bulletinData.content;
    }

    cancelEditingBulletin(bulletinData: any) {
        // reset 编辑区
        this.bulletinEditingStage = { id: null, content: null };
        if (bulletinData.id == null) {
            this.bulletins.pop();
        }
    }

    deletBulletin(bulletinData: any) {
        this.$mtd
            .confirm({
                message: '确认删除？',
                onOk: async () => {
                    const res = await api.rgApi.deleteBulletin(bulletinData.id);
                    if (res.code === 200) {
                        this.$mtd.message({ message: '删除成功', type: 'success' });
                        this.getMosesBulletins();
                    } else {
                        this.$mtd.message({ message: '删除失败', type: 'error' });
                    }
                }
            })
            .catch(e => {
                console.log(e);
            });
    }

    validateBulletin(): Promise<boolean> {
        return new Promise(resolve => {
            (this.$refs.bulletinEditingForm as Form)
                .validate(valid => {
                    resolve(valid);
                })
                .catch(e => {
                    console.log(e);
                    resolve(false);
                });
        });
    }

    async saveEditingBulletin() {
        const valid = await this.validateBulletin();
        if (!valid) return;

        if (this.bulletinEditingStage.id == null) {
            try {
                const res = await api.rgApi.addMosesBulletin({
                    rgId: this.rgId,
                    content: this.bulletinEditingStage.content
                });
                if (res.code === 200) {
                    const idx = this.bulletins.map(item => item.id || null).indexOf(this.bulletinEditingStage.id);
                    const addeBulletin = res.data;
                    this.bulletins[idx] = { ...addeBulletin };
                    this.bulletinEditingStage = { id: null, content: null };
                } else {
                    this.$mtd.message({ message: res.message, type: 'error' });
                }
            } catch (e) {
                console.log(e);
            }
        } else {
            try {
                const res = await api.rgApi.updateBulletin({
                    rgId: this.rgId,
                    id: this.bulletinEditingStage.id,
                    content: this.bulletinEditingStage.content,
                    enable: true
                });
                if (res.code === 200) {
                    const idx = this.bulletins.map(item => item.id || null).indexOf(this.bulletinEditingStage.id);
                    const updateBulletin = res.data;
                    this.bulletins[idx] = { ...updateBulletin };

                    this.$mtd.message({ message: '修改成功', type: 'success' });
                    this.bulletinEditingStage = { id: null, content: null };
                } else {
                    this.$mtd.message({ message: res.message, type: 'error' });
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    // 设置 bulletin 是否启用
    async toggleBulletinEnable(bulletinData: any, enable: boolean) {
        const { id } = bulletinData;
        if (id == null) {
            return;
        }
        const res = await api.rgApi.updateBulletin({ ...bulletinData, enable });
        if (res.code === 200) {
            this.$mtd.message({ message: '设置成功', type: 'success' });
            this.getMosesBulletins();
        }
    }
}
